<template>
  <div class="wui-container coupon_rule">
    <div>

      <h5>引言</h5>
      <p>
        本《Wellcee唯心所寓房源推广服务协议》旨在规范平台向会员提供的特定房源推广服务（下称“推广服务”）。如您购买或使用本推广服务，即表示您已阅读、理解并同意接受本补充协议及《Wellcee唯心所寓会员增值服务协议》的全部内容约束。
      </p>
      <h5>1. 服务定义</h5>
      <p>
        &ensp;1.1 推广服务：指用户通过支付相应费用，将其在Wellcee平台发布的特定房源信息在平台约定的特定位置、通过特定技术手段（如增加曝光量、优先排序等）进行展示和推广的增值服务。
      </p>
      <p>
        &ensp;1.2 推广审核：用户提交的房源信息及推广申请，须经Wellcee平台审核。审核标准包括但不限于房源信息的真实性、完整性、合规性及是否符合平台管理规范。审核通过是启动推广服务的前提条件。
      </p>
      <h5>2. 服务费用与支付</h5>
      <p>
        &ensp;2.1 您应按照服务购买页面显示的费用标准支付推广服务费。费用支付成功后，即视为您与Wellcee平台就本次推广服务达成了协议。
      </p>
      <p>
        &ensp;2.2 重要约定：费用性质与不可退还
      </p>
      <p>
        &emsp;您支付的推广服务费是对应于本次推广服务机会的对价，其性质是为获取特定推广资源而支付的商业成本，而非预付款或保证金。鉴于推广服务在审核通过后即开始消耗平台的推广资源与计算能力，且该服务效果具有即时性、不可储存和不可逆的特性，您确认并同意：一旦您的推广申请通过审核且推广服务正式启动，无论您此后是否主动中止服务、房源信息发生任何变更或因任何其他原因导致推广效果未达预期，您已支付的推广服务费用均不予退还。
      </p>
      <h5>3. 服务启动、中止与终止</h5>
      <p>&ensp;3.1 服务启动：推广服务的启动时间以平台系统通过审核正式上线时间为准，而非您支付成功的时间。服务期限以通过审核后开始计算。</p>
      <p>&ensp;3.2 服务中止或终止：</p>
      <ul>
        <li>&ensp;○ 因用户原因：若因您违反平台规则（包括但不限于发布虚假信息、被认定为中介行为等）导致推广服务被中止或终止，已支付费用不予退还</li>
        <li>&ensp;○ 因平台原因：如因平台可控范围外的不可抗力、技术故障等原因导致推广服务无法继续，平台将依据实际情况尽力恢复服务或提供合理的解决方案，但原则上不承担退还已消耗服务周期对应费用的义务。</li>
        <li>&ensp;○ 协商终止：除法律法规另有强制性规定外，基于本协议第2.2条的约定，推广服务启动后，不接受任何形式的退款或终止退费请求。</li>
      </ul>
      <h5>4. 用户承诺与保证</h5>
      <p>&ensp;4.1 您保证申请推广的房源信息真实、准确、合法、有效，并拥有完整的处分权或已获得相关权利人的合法授权。</p>
      <p>&ensp;4.2 您理解并同意，平台提供的是信息推广的技术服务，不对房源的实际租赁效果（如询盘量、成交率等）作任何明示或默示的担保。推广效果可能受市场环境、房源条件、价格等多种因素影响。</p>
      <h5>5. 其他</h5>
      <p>&ensp;5.1 Wellcee平台有权根据业务发展需要修改本补充协议内容。修改后的协议将在平台公布后生效。若您继续使用，则视为接受修改后的协议。</p>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { useRoute } from "vue-router";

export default {
  data() {
    return {
      email: 'maxim@wellcee.com',
      lang: '',
    };
  },
  mounted() {
    const route = useRoute();
    this.lang = ['zh', 'en', 'tw'].includes(route.query.lang) ? route.query.lang : 'zh';
    if (route.query.theme == 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    }
    if (route.query.lang && ['zh', 'en', 'tw'].includes(route.query.lang)) {
    }
    document.title = "Wellcee唯心所寓房源推广服务协议"
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
.coupon_rule{
  box-sizing: border-box;
  min-height: 100vh;
  overflow: hidden;
  padding: 30px;
  background-color: var(--wlc-bg-white);
  font-size: 14px;
  color: #666666;
  line-height: 21px;
  li{
    list-style: none;
  }
}
.coupon_rule h5{
  font-size: 14px;
  font-weight: bold;
  margin: 20px 0 6px 0;
}
.coupon_rule h5:first-child{
  margin-top: 0;
}
.coupon_rule p{
  margin: 6px 0;
}
.coupon_rule ul{
  list-style: decimal;
  list-style-position: inside;
}
.coupon_rule ul li{
  margin: 6px 0;
}
</style>
